import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/lib/cn';
import type { AdminSubscriptionMonitorItem } from '../types/adminSubscription';

interface MonitorDaysBadgeProps {
  item: AdminSubscriptionMonitorItem;
  className?: string;
}

export function MonitorDaysBadge({ item, className }: MonitorDaysBadgeProps) {
  const { t } = useTranslation();
  const days = item.days_remaining;

  if (days === null) {
    return (
      <span className={cn('text-xs text-muted-foreground', className)}>
        {t('trials.daysRemaining.unavailable')}
      </span>
    );
  }

  if (
    days < 0 ||
    item.subscription_status === 'expired' ||
    item.subscription_status === 'cancelled'
  ) {
    return (
      <span
        className={cn(
          'inline-flex items-center rounded-full bg-red-100 px-2.5 py-0.5 text-xs font-medium text-red-700 dark:bg-red-900/30 dark:text-red-400',
          className,
        )}
      >
        {t('trials.daysRemaining.expired')}
      </span>
    );
  }

  if (days === 0) {
    return (
      <span
        className={cn(
          'inline-flex items-center rounded-full bg-amber-100 px-2.5 py-0.5 text-xs font-medium text-amber-700 dark:bg-amber-900/30 dark:text-amber-400',
          className,
        )}
      >
        {t('trials.daysRemaining.today')}
      </span>
    );
  }

  const isUrgent =
    days <= 7 && (item.subscription_status === 'trialing' || item.subscription_status === 'active');

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        isUrgent
          ? 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400'
          : 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400',
        className,
      )}
    >
      {t('trials.daysRemaining.left', { count: days })}
    </span>
  );
}
